import { ApiResponse } from "../CustomFetch";
import { api } from "./BaseApi";
import { ExpertViewModel } from "../../model/ExpertViewModel";
import { orderBy } from "lodash";

const getExpertUrl = (id?: string) => "/Expert" + (id === undefined ? "" : `/${id}`);

const expertsApi = api.enhanceEndpoints({ addTagTypes: ["Experts"] }).injectEndpoints({
  endpoints: (builder) => ({
    getExperts: builder.query<ExpertViewModel[], void>({
      query: () => getExpertUrl(),
      transformResponse: (response: ApiResponse<ExpertViewModel[]>) =>
        orderBy(response.data, (expert) => expert.lastName.toLowerCase()),
      providesTags: (result) =>
        result
          ? [...result.map(({ id }) => ({ type: "Experts" as const, id })), { type: "Experts", id: "LIST" }]
          : [{ type: "Experts", id: "LIST" }],
    }),
    getExpert: builder.query<ExpertViewModel, string>({
      query: getExpertUrl,
      transformResponse: (response: ApiResponse<ExpertViewModel>) => response.data,
      providesTags: (_result, _error, arg) => [{ type: "Experts", id: arg }],
    }),
    deleteExpert: builder.mutation<ApiResponse<void>, string>({
      query: (id) => ({
        url: getExpertUrl(id),
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Experts", id: "LIST" }],
    }),
    createExpert: builder.mutation<ApiResponse<void>, ExpertViewModel>({
      query: (expert: ExpertViewModel) => ({
        url: getExpertUrl(),
        body: expert,
        headers: { "Content-Type": "application/json" },
        method: "POST",
      }),
      invalidatesTags: [{ type: "Experts", id: "LIST" }],
    }),
    updateExpert: builder.mutation<ApiResponse<void>, ExpertViewModel>({
      query: (expert: ExpertViewModel) => ({
        url: getExpertUrl(),
        body: expert,
        headers: { "Content-Type": "application/json" },
        method: "PUT",
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: "Experts", id: "LIST" },
        { type: "Experts", id: arg.id },
      ],
    }),
  }),
});

export const {
  endpoints,
  useGetExpertsQuery,
  useGetExpertQuery,
  useDeleteExpertMutation,
  useCreateExpertMutation,
  useUpdateExpertMutation,
} = expertsApi;
